import setWith from 'lodash/setWith';
import clone from 'lodash/clone';
import { getBucketData } from 'lib/utilityFunctions';
import gameIds from '../data/GameIds';
import { persistStateTypes } from '../../reducers/persistStateReducer';

let notebookBucket = {};

export const initialState = {
  version: 1,
  lastMasteredId: undefined,
  quests: {
    201: {
      autoTransition: false,
      singlePageLayout: true,
      selectedOptions: [],
    },
    202: {
      autoTransition: true,
      singlePageLayout: true,
      selectedOptions: [],
    },
    203: {
      autoTransition: true,
      singlePageLayout: true,
      selectedOptions: [],
    },
    204: {
      autoTransition: true,
      singlePageLayout: true,
      selectedOptions: [],
    },
    205: {
      autoTransition: true,
      singlePageLayout: true,
      selectedOptions: [],
    },
    206: {
      autoTransition: true,
      singlePageLayout: true,
      selectedOptions: [],
    },
    207: {
      autoTransition: true,
      singlePageLayout: true,
      selectedOptions: [],
    },
    208: {
      autoTransition: true,
      singlePageLayout: true,
    },
    209: {
      autoTransition: true,
      singlePageLayout: true,
    },
    210: {
      autoTransition: true,
      singlePageLayout: true,
    },
    211: {
      autoTransition: true,
      singlePageLayout: true,
    },
    212: {
      autoTransition: true,
      singlePageLayout: true,
    },
    213: {
      autoTransition: true,
      singlePageLayout: true,
    },
    214: {
      autoTransition: true,
      singlePageLayout: true,
    },
    215: {
      autoTransition: true,
      singlePageLayout: true,
    },
    216: {
      autoTransition: true,
      singlePageLayout: true,
    },
    217: {
      autoTransition: true,
      singlePageLayout: true,
    },
    218: {
      autoTransition: true,
      singlePageLayout: true,
    },
    219: {
      autoTransition: true,
      singlePageLayout: true,
    },
    220: {
      autoTransition: true,
      singlePageLayout: true,
    },
    221: {
      autoTransition: true,
      singlePageLayout: true,
    },
    222: {
      autoTransition: true,
      singlePageLayout: true,
    },
    223: {
      autoTransition: true,
      singlePageLayout: true,
    },
  },
};

const notebookReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'SET_NOTEBOOK_PROGRESS': {
      const updatedProgressState = setWith(clone(state), 'lastMasteredId', action.payload.questId, clone);
      return setWith(
        clone(updatedProgressState),
        `quests.${action.payload.questId}.selectedOptions`,
        action.payload.value,
        clone,
      );
    }
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL:
      notebookBucket = (getBucketData(
        action.stateData[gameIds.METAGAME_QUEST_NOTEBOOK],
      ) || {}).gameDetails || state;
      return {
        ...state,
        lastMasteredId: notebookBucket.lastMasteredId !== undefined ? notebookBucket.lastMasteredId
          : state.lastMasteredId,
        quests: notebookBucket.quests !== undefined ? { ...state.quests, ...notebookBucket.quests } : state.quests,
      };
    default:
      return state;
  }
};

export default notebookReducer;
